import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';



import { UtilService } from './util-service';

import { Pca } from '../models/Pca';
import { JurisdicionadoService } from './jurisdicionado-service';

import { UsuarioService } from './usuario-service';

declare var jsPDF: any;

/*
  Generated class for the GestaoPcaService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class GestaoPcaService {

  PCASelecionada: any;
  private subject = new Subject<any>();


  constructor(public jurisdicionadoService: JurisdicionadoService,
          public usuarioService: UsuarioService,
          private utilService: UtilService) {

  }

  public setPCA(PCAinfo = null) {
    let selecionada: boolean = false;

    if (PCAinfo != null) {
      this.PCASelecionada = this.geradorPCA(PCAinfo);
      selecionada = true;
    }
    else {
      this.PCASelecionada = new Pca();
    }

    this.subject.next({ PCA: this.PCASelecionada, selecionada: selecionada });
  }

  public setPCAModulos(Modulosinfo) {
    this.PCASelecionada.modulos = Modulosinfo;
  }

  public getPCA() {
    return this.PCASelecionada;
  }

  public getPCAObservable(): Observable<any> {
    return this.subject.asObservable();
  }

  public isPCASet() {
    if (this.getPCA() != null) {
      return true;
    } else {
      return false;
    }
  }

  public geradorPCA(PCAinfo) {
    return new Pca(PCAinfo);
  }

  public isPCAAberta() {
    if (this.PCASelecionada.idStatus <= 2 || this.PCASelecionada.idStatus == 6) {
      return true;
    }

    return false;
  }

  gerarCertificadoRetificacao(pca: any): Observable<any> {
    return Observable.create( observer => {
      
      try {
        let file: File = null;
        let protocolo = 0;
        let dtProtocolo;

        if (pca.idProtocoloGeralRatificado > 0) {
          protocolo = pca.nrProtocoloGeralRetificado;
        }

        this.obterDataProtocolo(protocolo).subscribe(data => {
          dtProtocolo = data.split(" ");

          console.log("PROTOCOLO: " + protocolo + " | " + dtProtocolo[0] + " "+ dtProtocolo[1]);

          var doc = new jsPDF('landscape');

          doc.setFont("times");
          doc.setFontType("normal");

          doc.text(150, 80, 'TRIBUNAL DE CONTAS DO ESTADO DO CEARÁ', null, null, 'center');
          doc.setFontType("bold");
          doc.text(150, 90, 'CERTIFICADO DE RECEBIMENTO', null, null, 'center');
          doc.text(150, 96, 'DA PRESTAÇÃO DE CONTAS RETIFICADORA', null, null, 'center');
          doc.setFontType("normal");
          doc.text(150, 105, pca.jurisdicionado.dsJurisdicionado.toUpperCase(), null, null, 'center');
          doc.text(150, 115, pca.dsAnoexercicio.toUpperCase(), null, null, 'center');
          doc.text(150, 125, 'PROTOCOLO: ' + protocolo, null, null, 'center');
          doc.text(150, 135, 'EM ' + dtProtocolo[0] + " às " + dtProtocolo[1], null, null, 'center');
          doc.text(150, 145, 'O status desse protocolo pode ser consultado em:', null, null, 'center');
          doc.text(150, 151, 'https://www.tce.ce.gov.br/cidadao/consulta-de-processos', null, null, 'center');

          var outputBase64 = doc.output('datauristring');
          var preBlob = this.dataURItoBlob(outputBase64);
          file = new File([preBlob], "protocolo-retificacao.pdf", { type: 'application/pdf' });
        }, error => {
          // this.alertService.mostraAlerta('Não foi possível criar o conteúdo do protocolo!', error);
          observer.error('Erro ao gerar o conteúdo do protocolo');
        });

        this.obterModuloPcaPorModuloPorPCA(0, pca.id).subscribe(data => {
          let moduloPca = data.idModuloPca;

          const PCA_CERTIFICADO_RETIFICACAO = 10001;
          this.salvarCertificadoPCA(file, pca.id, moduloPca, PCA_CERTIFICADO_RETIFICACAO, 0, 0, "Certificado Retificação").subscribe(data => {
            // this.alertService.mostraAlerta("Protocolo", "Protocolo Gerado com Sucesso");
            // this.isSubmetendo = false;
            // this.carregaListaPCAS();
            observer.next(data.idArquivoVinculado);
          }, error => {
            //this.isSubmetendo = false;
            //this.alertService.mostraAlerta('Não foi possível gerar o protocolo !', error);
            console.log(error);
            observer.error('Não foi possível salvar o certificado de retificação.' + error);
          });

        }, error => {
          // this.isSubmetendo = false;
          // this.alertService.mostraAlerta("Certificado", "Não foi posível identificar Modulo PCA.");
          observer.error('Não foi posível identificar Modulo PCA.' + error);
        });
      } catch (error) {
        // this.isSubmetendo = false;
        observer.error('Falhar ao gerar os dados e gravar o certificado de retificação.');
      }

    })
  }

  private dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(dataURI.split(',')[1]);
    else
      byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

    // Metodo exclusivo para Salvar Certificado no submeter PCA
  private salvarCertificadoPCA(file: File, idPca, pcodigoModuloPCA, ptipoAnalise, pTipoEntidadeExercicio, pTipoDocumento, origemArquivo) {
    let formData: FormData = new FormData();
    formData.append('arquivo', file, file.name);
    let envioPeca: string = "arquivo/salvar?id=" + idPca + "&codigoModulo=" + pcodigoModuloPCA + "&idPca=" + idPca + "&cdTipoAnalise=" + ptipoAnalise + "&tipoEntidadeExercicio=" + pTipoEntidadeExercicio + "&tipoDocumento=" + pTipoDocumento + "&dsOrigemArquivo=" + origemArquivo;
    return this.utilService.postArquivo(envioPeca, formData);
  }


  /* =================================================================================
  *
  *   Requisições com o servidor
  *
  * ================================================================================== */

  //Obtem lista de PCAs
  public listarTodasPCAS(): Observable<any> {
    let urlObtencaoDados: string;
    urlObtencaoDados = "pca/listar";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarTodasPCASJUrisdicionado(idEntidade): Observable<any> {
    let urlObtencaoDados = "pca/listarPorJurisdicionado?idEntidade=" + idEntidade;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public obterModulosPorPCA(idPCA): Observable<any> {
    let urlObtencaoDados: string = "modulo/obterPorPCA/" + idPCA;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public obterModulosPorPCAJurisdicionado(idPCA): Observable<any> {
    let urlObtencaoDados: string = "modulo/obterPorPCAJurisdicionado/" + idPCA;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public obterModuloPcaPorPCA(idPCA): Observable<any> {
    let urlObtencaoDados: string = "modulo/obterModuloPcaPorPCA?idPCA=" + idPCA;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public submeterPCA(idPCA, idUsuario, idStatus): Observable<any> {
    let urlObtencaoDados = "pca/submeterPca/" + idPCA + "?idUsuario=" + idUsuario + "&idStatus=" + idStatus;
    // let urlObtencaoDados = "pca/submeterPca/" + idPCA + "?idUsuario=" + idUsuario;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public obterDataProtocolo(protocolo): Observable<any> {
    let urlObtencaoDados = "pca/dataProtocolo/" + protocolo;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public importarEmpenhos(idPCA): Observable<any> {
    let urlObtencaoDados = "pca/importarEmpenhos/" + idPCA;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public importarContratos(idPCA) {
    let urlObtencaoDados = "contrato/importarContratos?idPca=" + idPCA;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public obterModuloPcaPorModuloPorPCA(idModulo, idPCA): Observable<any> {
    let urlObtencaoDados: string = "modulo/obterModuloPcaPorModuloPorPCA?idModulo=" + idModulo + "&idPCA=" + idPCA;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public obterModuloPcaPorPCAPorModulo(idPCA, idModulo): Observable<any> {
    let urlObtencaoDados: string = "pca/obterModuloPca?idModulo=" + idModulo + "&idPca=" + idPCA;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public obterModuloAnalise(idModuloAnalise): Observable<any> {
    let urlObtencaoDados: string = "pca/obterModuloAnalise?idModuloAnalise=" + idModuloAnalise;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public obterPCAPorId(idPCA): Observable<any> {
    let urlObtencaoDados: string = "pca/obter/" + idPCA;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarPCA(novaPca, idEntidade, dsEntidade): Observable<any> {
    let urlObtencaoDados: string = "pca/salvar";
    this.jurisdicionadoService.setJurisdicionado(idEntidade, dsEntidade);
    novaPca.jurisdicionado = this.jurisdicionadoService.getJurisdicionado();
    return this.utilService.postJSON(urlObtencaoDados, novaPca);
  }

  public justificarModulo(moduloPca): Observable<any> {
    console.log(JSON.stringify(moduloPca));
    let urlObtencaoDados: string = "pca/justificarModulo";
    return this.utilService.postJSON(urlObtencaoDados, JSON.stringify(moduloPca));
  }

  public justificarModuloAnalise(moduloAnalise): Observable<any> {
    let urlObtencaoDados: string = "pca/justificarModuloAnalise";
    return this.utilService.postJSON(urlObtencaoDados, moduloAnalise);
  }

  public salvarRetificacao(jsonObjeto): Observable<any> {
    let urlObtencaoDados: string = "saneamento/salvar";
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }

  public enviarRetificacao(jsonObjeto): Observable<any> {
    let urlObtencaoDados: string = "saneamento/sanear";
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }

  public obterRetificacao(idSaneamento): Observable<any> {
    let urlObtencaoDados: string = "saneamento/obter?id=" + idSaneamento;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public obterListaModuloAnalise(lista, idPCA): Observable<any> {
    let urlObtencaoDados: string = "pca/recuperaListaModuloAnalise?listaIdModuloPca=" + lista + "&idPca=" + idPCA;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarModuloPorModuloPcaPorPCA(idPCA): Observable<any> {
    let urlObtencaoDados: string = "modulo/listarModuloPorModuloPcaPorPCA?idPCA=" + idPCA;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarModulos(): Observable<any> {
    let urlObtencaoDados: string = "modulo/listarModulos";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarModulosAutuacao(): Observable<any> {
    let urlObtencaoDados: string = "modulo/listarModulosAutuacao";
    return this.utilService.getJSON(urlObtencaoDados);
  }
}



// WEBPACK FOOTER //
// ./src/providers/gestao-pca-service.ts